<template>
  <div id="live">
    <div class="bg"></div>
    <div class="live-box">
      <div class="fullScreenBox">
        <div class="video-header">
          <div class="header-left">
            <div class="icon"></div>
            <div class="title">
              <div class="label-box">
                <span class="label-shadow">{{ liveInfo.title }}</span>
                <span class="label-text">{{ liveInfo.title }}</span>
              </div>
            </div>
            <div class="type" v-if="liveInfo.is_online">直播</div>
            <div class="audience" v-if="liveInfo.is_online">
              <i></i>
              <span>{{ liveInfo.audience }}</span>
            </div>
          </div>
          <!-- <div class="outerline">
            <a href="https://www.taptap.cn/" >这是一个外部链接</a>
          </div> -->
        </div>
        <div class="video-container">
          <VideoPlayer
            ref="videoPlayer"
            :liveInfo="liveInfo"
            :feedBackStatus="feedBackStatus"
          >
          </VideoPlayer>
          <div class="errorPrompt" v-if="showPrompt">
            <div class="prompt">{{ errorPrompt }}</div>
          </div>
        </div>

        <!-- 隐藏的战队信息 -->
        <div class="switch-source">
          <LiveRoom
            :list="liveRoomList"
            :data="cheerForList"
            @updatelivelink="handleLiveEvent"
            @openIncentives="handleGetAmount"
            @tryQuiz="handleQuizButton"
            @openPrizeMoney="handleShowPrizeMoney"
          >
          </LiveRoom>
        </div>
      </div>
    </div>
    
    <!-- 侧边栏 -->
    <div class="side-box">
      <div class="side-inner">
        <div class="title">
          <div
            class="tab title-schedule"
            :class="{ active: activeTab === 'schedule' }"
            @click="changeTab('schedule')"
          >
            <div class="label-box">
              <span class="label-shadow">赛程</span>
              <span class="label-text">赛程</span>
            </div>
          </div>
          <div
            class="tab title-rank"
            :class="{ active: activeTab === 'rank' }"
            @click="changeTab('rank')"
          >
            <div class="label-box">
              <span class="label-shadow">排行</span>
              <span class="label-text">排行</span>
            </div>
          </div>
        </div>
        <div class="side-content">
          <div class="inner-box" ref="sideScheduleBox"  :class="{ clearActive: activeTab === 'rank' }">
            <SideSchedule
              v-if="activeTab === 'schedule'"
              :scoreModal="scoreModal"
              :teamsModal="teamsModal"
              :arrangeList="arrangeList"
              :handleAnchor="handleAnchor"
            >
            </SideSchedule>
            <SideRank
              :rankType="rankType"
              v-if="activeTab === 'rank'"
            >
            </SideRank>
          </div>
        </div>
      </div>
    </div>
    <ScoreList ref="scoreModal"></ScoreList>
    <ParticipateTeams ref="teamsModal"></ParticipateTeams>
    <!-- 竞猜展示 -->
    <LiveQuiz
      ref="liveQuiz"
      :token="this.token"
      :liveQuizList="liveQuizList"
      @custom-event="handleQuizButton"
    >
    </LiveQuiz>

    <GetAmount ref="getAmount"></GetAmount>
    <PrizeMoney ref="prizeMoney"></PrizeMoney>
    <Prompt ref="prompt"></Prompt>
  </div>
</template>

<script>
import * as api from '@/service/index'
import _ from 'lodash'
import { mapMutations, mapState } from 'vuex'
import VideoPlayer from '@/views/live/video.vue'
import SideSchedule from '@/views/live/sideSchedule'
import SideRank from '@/views/live/sideRank'
import LiveRoom from '@/views/live/liveRoom'
import ScoreList from '@/views/schedule/scoreList'
import ParticipateTeams from '@/views/schedule/participateTeams'
import LiveQuiz from '@/views/live/live-quiz'
import GetAmount from '@/views/quiz/amount'
import PrizeMoney from '@/views/live/prize-money'
// import TipDot from '@/components/tip-dot.vue'
import Prompt from '@/components/prompt'



export default {
  components: {
    VideoPlayer,
    // SelectList,
    SideSchedule,
    ScoreList,
    ParticipateTeams,
    LiveQuiz,
    GetAmount,
    // TipDot,
    LiveRoom,
    SideRank,
    PrizeMoney,
    Prompt
  },
 
  data() {
    return {
      newSrc: '',
      showSelect: false,
      errorPrompt: '',
      networkStatus: 'online',
      showPrompt: false,

      type: 0,
      is_online: 1,

      dateZh: ['日', '一', '二', '三', '四', '五', '六'],
      seasonList: [],
      subSeason: {},
      subSeasonID: '',
      arrangeList: [],
      currentTime: '',
      liveQuizList: [],
      subScheduleTeams: [],
      // liveLink: 'https://xcc.xindong.com/api/v2.1/lives/1-1199535425545?game_id=58881',
      // socket :null
      // 默认第一个直播源
      // liveLink :'',
      liveRoomList: [],
      cheerForList: [],
      presentList: [], //  商品列表
      activeTab: 'schedule',
      rankType: ''
    }
  },

  computed: {
    ...mapState([
      'liveInfo',
      'token',
      'uid',
      'fullScreen',
      'userInfo',
      'isHintLive',
      'seasonInfo',
      // 'liveRoomList' //直播间数据
      'showLingqu'
    ])
  },
  watch: {
    seasonInfo: {
      handler(newVal) {
        if (newVal && newVal.id) {
          this.subSeasonID = newVal.id
          // 先请求赛季列表seasonList, 包含所有赛季，以及每个赛季设置的比赛阶段
          this.getArrangeSeasons()
          // 获取当前赛季的参赛队伍
          this.initQuiz()
        }
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.getConfig()
  },

  mounted() {
    window.addEventListener('offline', () => {
      this.networkStatus = 'offline'

      this.feedBackStatus()
    })
    window.addEventListener('online', () => {
      this.networkStatus = 'online'

      this.feedBackStatus(0, true)
    })
  },
  beforeDestroy() {
    this.$refs.videoPlayer && this.$refs.videoPlayer.pause()
    // console.log('beforeDestroy');
  },

  methods: {
    ...mapMutations(['SET_INFO', 'SET_LIVEINFO', 'SET_SHOWLINGQU']),
    getArrangeSeasons() {
      // console.log('getArrangeSeasons')
      if(!this.token) return;
      api.reqArrangeSeasons({ token: this.token }).then((response) => {
        if (response.status == 200) {
          // 所以赛季信息
          this.seasonList = response.data
          // 获取当前服务器时间
          api.reqcurrentTime().then((response) => {
            if (response.status == 200) {
              this.currentTime = new Date(response.data).getTime()
            } else {
              this.currentTime = new Date()
            }
            this.switchSeason(this.subSeasonID)
          })
        } else {
          alert(response.data)
        }
      })
    },
    // handleSwitch(hls) {
    //   this.showSelect = false;
    //   // this.$refs.videoPlayer.updateHls(hls);
    // },
    hasAgeValue(arr, targetValue) {
      return arr.some((obj) => obj.status == targetValue)
    },
    async fetchActivityList() {
      if(!this.token) return;
      try {
        const res = await api.getActivityList(this.token)
        // console.log('res', res)
        if (res.status === 200) {
          // console.log('ressss', res)
          const { dailyTasks } = res.data
          this.listData = dailyTasks
        }
      } catch (err) {
        console.log(err)
      }
    },
    feedBackStatus(type, is_online) {
      this.type = type
      this.is_online = is_online
      if (this.networkStatus == 'online') {
        this.errorPrompt = ''
        this.showPrompt = false

        //type 0: wifi  1: 流量  2: videojs错误 3: 兼容性，安卓版本太低
        if (!this.is_online || this.type == 2) {
          this.errorPrompt = '主播已下线'
          this.showPrompt = true
        } else if (this.is_online && this.type == 1) {
          this.errorPrompt = '当前正在使用非WiFi网络，继续播放将产生流量费用'
          this.showPrompt = true
        }
      } else {
        this.errorPrompt = '当前网络不可用'
        this.showPrompt = true
      }
    },
    switchSeason(id) {
      // 侧边栏 赛程简介
      let subSeason = this.seasonList.find((season) => season.id == id)
      if (subSeason) {
        // 当前赛季ID
        this.subSeasonID = subSeason.id
        // 当前赛季安排
        let arrangeList = []
        subSeason.scheduleList.forEach((schedule) => {
          let category = {}
          // 格式化每天的安排
          let dateObj = new Date(schedule.startAt)
          category.day = this.formatDay(dateObj)
          category.week = `周${this.dateZh[dateObj.getDay()]}`
          category.time = this.formatTime(dateObj)
          category.title = schedule.name
          category.teams = schedule.teamList || []
          if (this.currentTime < new Date(schedule.startAt)) {
            category.status = 1
          } else if (
            this.currentTime >= new Date(schedule.startAt) &&
            this.currentTime <= new Date(schedule.endAt)
          ) {
            category.status = 2
          } else {
            category.status = 3
          }
          category.scheduleCode = schedule.scheduleCode

          // 添加到对应那天的赛程安排中
          arrangeList.push(category)
        })

        this.arrangeList = arrangeList
      }
    },
    formatDay(dateObj) {
      let month = dateObj.getMonth() + 1
      month = month < 10 ? '0' + month : month
      let day = dateObj.getDate()
      day = day < 10 ? '0' + day : day

      return `${month}月${day}日`
    },
    formatTime(dateObj) {
      let hour = dateObj.getHours()
      hour = hour < 10 ? '0' + hour : hour
      let min = dateObj.getMinutes()
      min = min < 10 ? '0' + min : min

      return `${hour}:${min}`
    },
    scoreModal(code, title) {
      this.$refs.scoreModal.initMatchDetail(code, title)
    },
    teamsModal(teams) {
      this.$refs.teamsModal.initTeams(teams)
    },
    handleAnchor(offsetTop) {
      this.$refs.sideScheduleBox.scrollTop = offsetTop
    },

  
    // 获取竞猜列表
    async handleQuizButton() {
      if(!this.token) return;
      try {
        let { status, data } = await api.realTimeGuessing(this.token)
        // console.log(data)
        if (status === 200) {
          this.liveQuizList = data
          this.$refs.liveQuiz.liveQuiz()
        }
      } catch (err) {
        console.error(err)
      }
    },

    async initQuiz() {
      // 获取所有赛程
      if(!this.token) return;
      let response = await api.reqScheduleList({
        seasonId: this.subSeasonID,
        token: this.token
      })
      if (response.status == 200) {
        if (response.data && response.data.length != 0) {
          let defaultScheduleID = response.data.find(
            (item) => item.isPresent
          ).scheduleCode
          this.getSubScheduleTeams(defaultScheduleID)
        }
      }
    },
    async getSubScheduleTeams(schedule_code) {
      if(!this.token) return;
      let response = await api.reqScheduleTeams({
        scheduleCode: schedule_code,
        seasonId: this.subSeasonID,
        token: this.token,
        questionId: 0
      })
      if (response.status == 200) {
        this.subScheduleTeams = response.data
      }
    },
    handleGetAmount() {
      this.$refs.getAmount.getAmount()
    },
    handleShowPrizeMoney() {
      this.$refs.prizeMoney.showModal()
    },

    async getConfig() {
      let response = await api.reqConfig()
      if (response.status == 200) {
        // console.log('response', response.data.gift_list)
        // console.log('123',response)
        // 获取赠送礼物列表
        this.presentList = response.data.gift_list
        this.liveRoomList = response.data.roomLive
        // console.log(' this.presentList', this.presentList)
        // 首次获取第一个直播源进行播放
        this.getLiveInfo(this.liveRoomList[0]?.value)
      }
    },

    async getLiveInfo(liveLink) {
      // console.log('liveLink', liveLink)
      try {
        const res = await api.getVideo(liveLink)
        // console.log('123');
        if (res.status == 200) {
          let data = res.data
          data.ld = ''
          data.hd = ''
          data.fhd = ''
          data.type = 'application/x-mpegURL'
          data.linesList = []
          let sources = data.sources
          if (sources && sources.length >= 1) {
            // 获取线路
            let linesList = []
            sources.forEach((item) => {
              let obj2 = {}
              obj2.name = item.name
              if (item.hls) {
                Object.keys(item.hls).forEach((key) => {
                  let source = item.hls[key]
                  if (source) {
                    obj2.id = source
                    return
                  }
                })

                if (obj2.name && obj2.id) {
                  linesList.push(obj2)
                }
              }
            })
            data.linesList = linesList

            if (linesList.length != 0) {
              data.hd = linesList[0]['id']
            }
          }
          // 将直播间信息存储至vuex, 再次返回live路由时，可跳过请求直接获取数据
          this.SET_LIVEINFO(data)
          this.feedBackStatus(0, data.hd ? true : false)
        }
      } catch (err) {
        console.log(err)
      }
    },
    handleLiveEvent(value) {
      this.getLiveInfo(value)
    },
    changeTab(tab) {
      this.activeTab = tab
    },
    handleBettingLimit(){
       this.$refs.prompt.setMsg('竞猜币已达上限,无法继续竞猜')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/live/index';
</style>